import { useEffect, useMemo } from "react";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import { AuthenticationStrategyType } from "utilities/enumerations/authorization";
import useCurrentIdentity from "utilities/hooks/use-current-identity";

// Help Docs: https://help.chameleon.io/en/articles/5703699-installing-using-npm
const chameleon = require("@chamaeleonidae/chmln"); // Seems to need CommonJS-style import rather than ES6; did not work otherwise

const CHAMELEON_ACCOUNT_KEY =
    "SMKDUSZV5DGH9gMmD4SNvhrnzyd56FN7Dnu5CQd3i2QZGD-1UUbYv-G9pwRM2wMMmwEUOw";

const Chameleon = () => {
    const { currentIdentity } = useCurrentIdentity();
    const { globalState } = useGlobalState();
    const isLoggedIn = globalState.isAuthenticated();

    const canInit = useMemo(() => {
        return (
            globalState.authStrategyType !==
            AuthenticationStrategyType.Emulation
        );
    }, [globalState.authStrategyType]);

    const isTrackableUser = useMemo(
        () => currentIdentity?.isTrackableUser() && canInit,
        [canInit, currentIdentity]
    );

    const chmln = window["chmln"];

    useEffect(() => {
        if (canInit) {
            chameleon.init(CHAMELEON_ACCOUNT_KEY, {
                fastUrl: "https://fast.chameleon.io/",
                forceOverride: true, // Prevents duplicate instances of Chameleon from being init'd at once
            });
        }
    }, [canInit]);

    useEffect(() => {
        if (chameleon && chmln) {
            if (isLoggedIn && isTrackableUser) {
                chameleon.identify(currentIdentity?.user?.netsuiteId, {
                    email: currentIdentity?.user?.email,
                    name: currentIdentity?.user?.getFirstAndLastName(),
                });
            } else {
                chmln.clear();
            }
        }
    }, [chmln, currentIdentity?.user, isTrackableUser, isLoggedIn]);

    return null;
};

export default Chameleon;
